export default __webpack_public_path__ + "static/media/Frame3.fe759101.png";